import React from 'react';
import { Table } from 'tabler-react';

const TableSkeleton = ({ 
  headers = [], 
  rows = 9, 
  title = "Elementos",
  isLoading = true 
}) => {
  if (!isLoading) return null;

  return (
    <div>
      {/* Skeleton para el total */}
      <div style={{ 
        textAlign: 'center', 
        fontSize: '32px', 
        fontWeight: 'bold', 
        marginBottom: '30px',
        color: '#467fcf'
      }}>
        Total de {title}: ...
      </div>

      {/* Skeleton para la tabla */}
      <div className="table-container">
        <Table responsive>
          <Table.Header>
            <Table.Row>
              {headers.map((header, index) => (
                <Table.ColHeader key={index}>{header}</Table.ColHeader>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {[...Array(rows)].map((_, rowIndex) => (
              <Table.Row key={rowIndex}>
                {headers.map((_, colIndex) => (
                  <Table.Col key={colIndex}>
                    <div style={{
                      height: colIndex === 0 ? '20px' : '16px',
                      backgroundColor: '#e5e7eb',
                      borderRadius: '4px',
                      animation: 'skeleton-pulse 1.5s ease-in-out infinite alternate',
                      animationDelay: `${(rowIndex * 0.1) + (colIndex * 0.05)}s`
                    }}></div>
                  </Table.Col>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};

export default TableSkeleton;
